<script lang="ts">
    import {Flex} from 'shared/layouts';
    import type {Fond} from 'src/typings';
    import {popInAnim, popOutAnim} from 'shared/animations';
    import type {DynamicFieldSearchParam, RecordRow, RowCreationParams} from 'src/features/record-grid/lib/types';
    import {getProjectReportOptimisationContext} from '../project-report-optimisation-context';
    import {onDestroy} from 'svelte';
    import {exists} from 'shared/utils/custom-utils';
    import {asFieldTypeId} from 'shared/utils/record-field-utils';
    import KpRecordGrid from 'src/features/record-grid/KpRecordGrid.svelte';
    import ReportOptimisationRowOptionsCell from './ReportOptimisationRowOptionsCell.svelte';
    import ReportOptimisationUsers from './users/ReportOptimisationUsers.svelte';

    export let fond: Fond;

    const context = getProjectReportOptimisationContext();

    let optimisedBusinessItemRecord: RecordRow | null = null;
    const optimisedBusinessItemRecordUnsubscribe = context.optimisedBusinessItemRecord$.subscribe((currentOptimisedBusinessItemRecord) => optimisedBusinessItemRecord = currentOptimisedBusinessItemRecord);
    const referenceFieldTypeId = asFieldTypeId('d1002.main');

    const dynamicFieldSearchParams: DynamicFieldSearchParam[] = [{
        fieldTypeId: referenceFieldTypeId,
        type: 'link',
        value: context.projectRecord.id
    }]
    const rowCreationParams: RowCreationParams = {initialValues: {[referenceFieldTypeId]: {recordId: context.projectRecord.id}}}

    onDestroy(() => {
        optimisedBusinessItemRecordUnsubscribe();
    });
</script>

<Flex class="report-optimisation-editation-tab" direction="column" fillAvailableSpace>
    <div class="overlay-container">
        {#if !exists(optimisedBusinessItemRecord)}
            <div class="grid-container record-grid-tab-page"
                 in:popInAnim={{key: 'grid'}}
                 out:popOutAnim={{key: 'grid'}}>

                <KpRecordGrid rowOptionsCellComponent={ReportOptimisationRowOptionsCell}
                              fondOrFondId={fond.id}
                              referenceRecordId={context.projectRecord.id}
                              {dynamicFieldSearchParams}
                              {rowCreationParams}
                              infiniteScroll/>
            </div>
        {:else}
            <div class="users-container" in:popInAnim={{key: 'users'}} out:popOutAnim={{key: 'users'}}>
                <ReportOptimisationUsers {optimisedBusinessItemRecord}/>
            </div>
        {/if}
    </div>
</Flex>

<style lang="less">
    @import (reference) "styles/portaro-erp.less";

    .overlay-container {
        .flex-grow();
        position: relative;

        .grid-container,
        .users-container {
            .flex-grow();
            align-items: start;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
    }
</style>